module.exports = __webpack_public_path__ + "static/img/st_sapele.91c67c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/launch/st_sapele.jpg
// module id = T91Y
// module chunks = 1